import { capitalize as capitalizeString } from "lodash";
import { ReactNode } from "react";

type RenderValueProps = {
  label: string;
  value?: string;
  capitalize?: boolean;
  infoAfter?: ReactNode;
};

export default function ReadOnlyValue({
  label,
  value,
  capitalize = false,
  infoAfter = null
}: RenderValueProps) {
  let formattedValue = value;
  if (value === undefined || value === "" || value === " ") {
    formattedValue = "-";
  } else {
    if (capitalize && formattedValue) {
      formattedValue = formattedValue
        .split(" ")
        .map((i: string) => `${capitalizeString(i)}`)
        .join(" ");
    }
  }

  return (
    <div className={"info-item"} style={{ width: "100%" }}>
      <p className="display-p-typo" style={{ marginBottom: 4 }}>
        {label}
      </p>
      <div className="secondary text-wrap" style={{ marginBottom: 4 }}>
        {formattedValue}
      </div>
      {infoAfter}
    </div>
  );
}
